import React from 'react';
import { PropTypes } from 'prop-types';
import { themePropType } from '@themes';
import { ChipBar } from './SearchChipBar.styles';
import { BuildChip } from './partials/BuildChip';
import { fieldsPropType } from '../utils';

function SearchChipBar({ fields, ...props }) {
  return (
    <ChipBar>
      {fields.map((field) => (
        <BuildChip key={field.label} {...props} field={field} />
      ))}
    </ChipBar>
  );
}

SearchChipBar.propTypes = {
  fields: fieldsPropType.isRequired,
  values: PropTypes.shape({}).isRequired,
  submitSearch: PropTypes.func.isRequired,
  theme: themePropType,
  setFieldValue: PropTypes.func.isRequired,
  resetBinders: PropTypes.shape({})
};

SearchChipBar.defaultProps = {
  resetBinders: {},
  theme: {}
};

export default SearchChipBar;
